import { Component, OnInit, ElementRef, OnDestroy } from '@angular/core';
import { AuthService } from '../_services/auth.service';
import { NotificationService } from '../_services/notification.service';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { ForgotPassDialogComponent } from './forgot-pass-dialog/forgot-pass-dialog.component';
import { User } from '../_models/user';
import { AbstractControl, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ErrorResponseService } from '../shared/errorResponse/errorResponse.service';
import { ChangeDialogComponent } from './changeDialog/changeDialog.component';
import { HttpClient } from '@angular/common/http';

declare var $: any;

@Component({
    selector: 'app-login-cmp',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css']
})

export class LoginComponent implements OnInit, OnDestroy {
    test: Date = new Date();
    private toggleButton: any;
    private sidebarVisible: boolean;
    private nativeElement: Node;
    private currUser: User;
    ipAddress = '';

    form = new UntypedFormGroup({
      username: new UntypedFormControl('', Validators.compose([Validators.required])),
      password: new UntypedFormControl('', Validators.compose([Validators.required])),
      
    });

    constructor(
        public authService: AuthService, 
        private notify: NotificationService, 
        private router: Router,
        private element: ElementRef, 
        private dialog: MatDialog,
        private errorResponseService: ErrorResponseService,
        private http:HttpClient
    ) { }

    ngOnInit() {
        this.removeTokens();
        this.nativeElement = this.element.nativeElement;
        this.sidebarVisible = false;
        this.getIPAddress();

        var navbar: HTMLElement = this.element.nativeElement;
        this.toggleButton = navbar.getElementsByClassName('navbar-toggle')[0];
        const body = document.getElementsByTagName('body')[0];
        body.classList.add('login-page');
        body.classList.add('off-canvas-sidebar');
        const card = document.getElementsByClassName('card')[0];
        setTimeout(function () {
            // after 1000 ms we add the class animated to the login/register card
            card?.classList && card.classList.remove('card-hidden');
        }, 700);
       
    }

    getErrorMessage(abstractControl: AbstractControl): string {
      if (abstractControl?.errors && (abstractControl?.errors?.required || abstractControl?.errors?.dirty)) {
        return 'Ovo polje je obavezno';
      }
    }

    changePasswordByRole(role: number): void {
        const user = {
            0: this.authService.getAdminUser(),
            1: this.authService.getClientUser(),
            2: this.authService.getServiceManUser()
        };

        this.openChangeDialog(user[role]);
        this.notify.warning('Izmenite privremenu lozinku');
    }

    login(): void {
        this.authService.loginSystem(this.form.value,this.ipAddress).subscribe(response => {
            response?.isTempPassword && this.changePasswordByRole(response.role);
        }, error => {
            this.errorResponseService.notify(error, 'Neuspešno logovanje! Ne postoji korisnik sa zadatim kredencijalima!');
        }, () => {

        });
    }

    login_OLD() {
      this.authService.login(this.form.value).subscribe(next => {
          if (this.authService.currentUser.isTempPassword === true) {
              this.openChangeDialog(this.authService.currentUser);
              this.notify.warning('Izmenite privremenu lozinku');
          } else {
              if (this.authService.currentUser.role === 0) {
                  this.router.navigate(['/dashboard']);
                  this.notify.success('Uspešno logovanje');
              } else if (this.authService.currentUser.role === 1) {
                  this.router.navigate(['/vehicles']);
                  this.notify.success('Uspešno logovanje');
              } else if (this.authService.currentUser.role === 2) {
                  this.router.navigate(['/freeModems']);
                  this.notify.success('Uspešno logovanje');
              }
          }
        }, error => {
            this.notify.error('Neuspešno logovanje! Ne postoji korisnik sa zadatim kredencijalima!');
        });
        
    }

    openChangeDialog(user: User) {
        const dialogRef = this.dialog.open(ChangeDialogComponent, {
            width: '500px',
            data: { user: user }
        });
    }

    sidebarToggle() {
        var toggleButton = this.toggleButton;
        var body = document.getElementsByTagName('body')[0];
        var sidebar = document.getElementsByClassName('navbar-collapse')[0];
        if (this.sidebarVisible == false) {
            setTimeout(function () {
                toggleButton.classList.add('toggled');
            }, 500);
            body.classList.add('nav-open');
            this.sidebarVisible = true;
        } else {
            this.toggleButton.classList.remove('toggled');
            this.sidebarVisible = false;
            body.classList.remove('nav-open');
        }
    }
    openDialog() {
        const dialogRef = this.dialog.open(ForgotPassDialogComponent, {
            width: '500px',
        });
    }
    ngOnDestroy() {
        const body = document.getElementsByTagName('body')[0];
        body.classList.remove('login-page');
        body.classList.remove('off-canvas-sidebar');
    }
    removeTokens() {
        localStorage.removeItem('token');
        localStorage.removeItem('admin-token');
        localStorage.removeItem('admin-user');

        localStorage.removeItem('client-token');
        localStorage.removeItem('client-user');
        
        localStorage.removeItem('serviceMan-token');
        localStorage.removeItem('serviceMan-user');

    }

    isFormControlTouched(control: AbstractControl): boolean {
        const isTouched = control?.touched,
              hasErrors = Boolean(control?.errors);

        return isTouched && hasErrors;
    }
    getIPAddress(){
        this.authService.getIPAddress().subscribe((data:any) => {
            this.ipAddress = data.ip;   
        })
    }

}
